// FAMILY-EXT: API-клиент для WebDAV-прокси Planka.

import http from './http';

const browse = (storageId, path = '/', headers) =>
  http.get(
    `/webdav/browse?storageId=${encodeURIComponent(storageId)}&path=${encodeURIComponent(path)}`,
    undefined,
    headers,
  );

export default {
  browse,
};
